<mat-dialog-content>
    This is a dialog
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Okay</button>
  </mat-dialog-actions>